import React, { ErrorInfo, PropsWithChildren, useCallback } from "react";
import {
  getErrorMessage,
  ErrorBoundary as InternalErrorBoundary
} from "react-error-boundary";
import { useRollbarInstance } from "src/gatsby/plugins/gatsby-plugin-rollbar/RollbarProvider";
import { reportError } from "src/gatsby/plugins/gatsby-plugin-rollbar/lazyRollbar";

export const IngoreErrorBoundary: React.FC<PropsWithChildren<unknown>> = ({
  children
}) => {
  const logError = useCallback((error: unknown, info: ErrorInfo) => {
    console.error(error, info);
  }, []);

  return (
    <InternalErrorBoundary onError={logError} fallback={<div />}>
      {children}
    </InternalErrorBoundary>
  );
};

const ErrorBoundary: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const rollbarInstance = useRollbarInstance();

  const logError = useCallback(
    (thrown: unknown, info: ErrorInfo) => {
      console.error(thrown, info);
      const error =
        thrown instanceof Error
          ? thrown
          : new Error(getErrorMessage(thrown) ?? String(thrown));
      if (rollbarInstance) rollbarInstance.error(error, info);
      // SDK not loaded yet: queue so the error survives until it is.
      else reportError(error.message, { error, info });
    },
    [rollbarInstance]
  );

  return (
    <InternalErrorBoundary onError={logError} fallback={<div />}>
      {children}
    </InternalErrorBoundary>
  );
};

export default ErrorBoundary;
